import { createSlice } from '@reduxjs/toolkit';
import { PagedSearch } from '../../../common/pagination/paginationTypes';
import { ActivityLogDto, ErrorResponse, PagedResultOfActivityLogDto } from '../../../common/PricePrgClient';
import { createAsyncAction } from '../../../utils';

const namespaces = {
    activityLogs: 'activityLogs'
};

export const fetchActivityLogs = createAsyncAction<PagedSearch, PagedResultOfActivityLogDto, ErrorResponse>(
    namespaces.activityLogs,
    'fetchActivityLogs'
);

export const fetchLoggableActionTypes = createAsyncAction<void, string[]>(
    namespaces.activityLogs,
    'fetchLoggableActionTypes'
);

const activityLogsSlice = createSlice({
    name: namespaces.activityLogs,
    initialState: {
        isLoading: false,
        activityLogs: [] as ActivityLogDto[],
        pagination: {
            pageIndex: 0,
            pageSize: 50,
            totalCount: 0,
            totalUnfilteredCount: 0,
            sortColumn: 'id',
            sortOrder: 'desc'
        } as PagedSearch & Omit<PagedResultOfActivityLogDto, 'rows'>,
        loggableActionTypes: [] as string[]
    },
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(fetchActivityLogs.request, (state, { payload }) => {
                state.isLoading = true;
                state.pagination = {
                    ...state.pagination,
                    ...payload
                };
            })
            .addCase(fetchActivityLogs.success, (state, { payload }) => {
                state.isLoading = false;
                state.activityLogs = payload.rows;
                state.pagination.totalCount = payload.totalCount;
                state.pagination.totalUnfilteredCount = payload.totalUnfilteredCount;
            })
            .addCase(fetchActivityLogs.failure, state => {
                state.isLoading = false;
            })
            .addCase(fetchLoggableActionTypes.success, (state, { payload }) => {
                state.loggableActionTypes = payload;
            })
});

export default activityLogsSlice.reducer;
